// types
import type { AdditionalSelectors, HostActions, TradeInConfig } from '../types';
import type { IAdditionalSelectors, Selectors, IConfigTradeIn } from '@makemydeal/dr-activities-tradein';
import { setGlobalSelector } from '@makemydeal/dr-activities-tradein';

// store
import { tradeInReducer } from './reducer';
import { MiddlewareManager } from './middlewareManager';
import { buildAdditionalSelectors, TradeInActivitySelectors, createTradeInConfigObject } from '../utils';
import { Selectors as sciSelector } from './selectors';

export let tradeinSelectors: any;
export let sciSelectors: any;
export let middlewareMgr: MiddlewareManager;

// Built once by init(). Rebuilding it per call would hand RootComponent a new `config`
// identity on every render.
let tradeInConfigObject: IConfigTradeIn | undefined;

// Getter function to access selectors at runtime (after init is called)
export const getTradeInSelectors = (): Selectors | undefined => tradeinSelectors;

// Getter function to access full IConfigTradeIn at runtime (after init is called)
export const getTradeInConfig = (): IConfigTradeIn | undefined => tradeInConfigObject;

export const init = (
    appName: string,
    additionalSelectors: IAdditionalSelectors,
    sciAdditionalSelectors: AdditionalSelectors,
    hostActions: HostActions,
    config: TradeInConfig,
    baseRoute: string
): {
    selectors: Selectors;
    manager: MiddlewareManager;
} => {
    tradeinSelectors = new TradeInActivitySelectors(appName, buildAdditionalSelectors(additionalSelectors));
    sciSelectors = new sciSelector(appName, sciAdditionalSelectors);

    middlewareMgr = new MiddlewareManager(tradeinSelectors, sciSelectors, hostActions, config, baseRoute);
    tradeInConfigObject = createTradeInConfigObject(config) as IConfigTradeIn;
    setGlobalSelector(tradeinSelectors);

    return {
        selectors: { ...tradeinSelectors, ...sciSelectors },
        manager: middlewareMgr
    };
};

export { tradeInReducer };
